import type { StateDeclarationFn } from 'controller/types';
import type { IApplicationUser } from 'store/application';

export default (function (vm) {
  return {
    name: 'my-groups.posts',
    url: '/posts',
    resolve: [
      {
        token: 'feed',
        deps: ['user'],
        resolveFn(user: IApplicationUser) {
          if (user.memberId) {
            return vm.centralFeed$.fetchByAuthor(user.memberId);
          }
        },
      },
    ],
  };
} as StateDeclarationFn);
